// import { EToastType, initToast } from './toastNotification';

const $socialShare = $('[social-share]');
const currentUrl = window.location.href;

const WINDOW =
	'toolbar=no, location=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=500, height=500';

enum ESocialType {
	FACEBOOK = 'facebook',
	TWITTER = 'twitter',
	LINKEDIN = 'linkedin',
	LINK = 'link',
}

export function initSocialShare() {
	$socialShare.on('click', function(this) {
		const $element = $(this);
		encodedUrl = encodeURIComponent(currentUrl);

		// get type of social share
		const type = $element.data('social-type');

		if (!!type) {
			var encodedUrl = '';

			encodedUrl = encodeURIComponent(currentUrl);

			switch (type) {
				case ESocialType.FACEBOOK:
					openSocialShareFacebook(encodedUrl);
					break;
				case ESocialType.TWITTER:
					openSocialShareTwitter(encodedUrl);
					break;
				case ESocialType.LINKEDIN:
					openSocialShareLinkedin(encodedUrl);
					break;
				case ESocialType.LINK:
					openSocialShareLink(window.location.href);
					break;
				default:
					return null;
			}
		}
	});
}

function openSocialShareFacebook(encodedUrl: string) {
	window.open(
		`https://www.facebook.com/sharer.php?u=${encodedUrl}`,
		'targetWindow',
		WINDOW,
	);
}

function openSocialShareTwitter(encodedUrl: string) {
	window.open(
		`http://twitter.com/share?url=${encodedUrl}&hashtags=nobleOak`,
		'targetWindow',
		WINDOW,
	);
}

function openSocialShareLinkedin(encodedUrl: string) {
	window.open(
		`https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
		'targetWindow',
		WINDOW,
	);
}

function openSocialShareLink(encodedUrl: string) {
	let $temp = $('<input>');
	$('body').append($temp);
	$temp.val(encodedUrl).select();
	document.execCommand('copy');
	$temp.remove();

	$('.social_share-success').css('opacity', '1');
	
	setTimeout(function() {
		$('.social_share-success').css('opacity', '0');
	}, 4000);
}



// WEBPACK FOOTER //
// ./scripts/components/socialShare.ts